import React from 'react';
import {Route, useParams} from 'react-router-dom';
import AsyncPage from './async';

const KeyedAsyncPage = () => {
  const {productType} = useParams();
  return <AsyncPage key={productType} />;
};

export default [
  <Route
    key="/business/products/:productType"
    path="business/products/:productType"
    element={<KeyedAsyncPage />}
  />,
];
